var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#7C39BF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,44.6c0,6.7,10,10.2,20,10.2s20-3.5,20-10.2C52,31.3,12,31.3,12,44.6z M32,48.5c-8.4,0-13.4-2.7-13.7-3.8 c0.3-1.2,5.3-3.9,13.7-3.9c8.4,0,13.4,2.7,13.7,3.8C45.4,45.7,40.4,48.5,32,48.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,32.4c6.4,0,11.6-5.2,11.6-11.6S38.4,9.2,32,9.2s-11.6,5.2-11.6,11.6S25.6,32.4,32,32.4z M32,15.5 c2.9,0,5.3,2.4,5.3,5.3S34.9,26,32,26s-5.3-2.4-5.3-5.3S29.1,15.5,32,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.6,44.6c0-0.1,0-0.2,0-0.2c-0.1,0-0.2-0.1-0.3-0.1c-0.9-0.4-1.5-0.7-1.9-1c0.4-0.3,1-0.7,1.9-1 c0.3-0.1,0.6-0.2,0.9-0.3c1.2-3,4.3-5.6,8.6-7.4c-0.2,0-0.5,0-0.7,0c-4.2,0-8.1,0.7-11.1,1.9c-1.5,0.6-2.9,1.4-4,2.4 c-1.1,1-2.1,2.6-2.1,4.5s1,3.4,2.1,4.5c1.1,1,2.5,1.8,4,2.4c1.9,0.7,4.1,1.3,6.5,1.6C11,49.7,9.6,47.2,9.6,44.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.1,38.7c-1.1-1-2.5-1.8-4-2.4c-3-1.2-6.9-1.9-11.1-1.9c-0.2,0-0.5,0-0.7,0c4.3,1.8,7.4,4.4,8.6,7.4 c0.3,0.1,0.6,0.2,0.9,0.3c0.9,0.4,1.5,0.7,1.9,1c-0.4,0.3-1,0.7-1.9,1c-0.1,0-0.2,0.1-0.3,0.1c0,0.1,0,0.2,0,0.2 c0,2.6-1.4,5.1-3.9,7.1c2.4-0.3,4.7-0.8,6.5-1.6c1.5-0.6,2.9-1.4,4-2.4c1.1-1,2.1-2.6,2.1-4.5S62.2,39.8,61.1,38.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46,21.1C46,21.1,46,21.1,46,21.1c1.4,0,2.5,1.1,2.5,2.5c0,1.4-1.1,2.5-2.5,2.5c-0.3,0-0.7-0.1-0.9-0.2 c-0.8,2-2,3.8-3.6,5.2c1.3,0.8,2.9,1.3,4.5,1.3c4.8,0,8.8-3.9,8.8-8.8c0-4.8-3.9-8.8-8.8-8.8c-0.4,0-0.9,0-1.3,0.1 c0.8,1.8,1.3,3.8,1.3,5.9C46,20.9,46,21,46,21.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18,32.3c1.7,0,3.2-0.5,4.5-1.3c-1.6-1.4-2.8-3.2-3.6-5.2C18.6,26,18.3,26,18,26c-1.4,0-2.5-1.1-2.5-2.5 c0-1.4,1.1-2.5,2.5-2.5c0,0,0,0,0,0c0-0.1,0-0.2,0-0.4c0-2.1,0.5-4.1,1.3-5.9c-0.4-0.1-0.8-0.1-1.3-0.1c-4.8,0-8.8,3.9-8.8,8.8 C9.2,28.4,13.1,32.3,18,32.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.a60eb241631d1d3ee37ba135d57ca3b7.svg";
export { ForwardRef as ReactComponent };